// src/App.js
import React from 'react';
import AdaptiveKeyboardApp from './components/AdaptiveKeyboardApp';

function App() {
  return <AdaptiveKeyboardApp />;
}

export default App;
